import api from "../../utils/Api";
import {
  VERIFY_LICENSE_REQUEST,
  VERIFY_LICENSE_SUCCESS,
  VERIFY_LICENSE_ERROR,
} from "./VerifyLicenseTypes";

export const verifyLicenseRequest = () => {
  return {
    type: VERIFY_LICENSE_REQUEST,
  };
};

export const verifyLicenseSuccess = (licenseStatus) => {
  return {
    type: VERIFY_LICENSE_SUCCESS,
    payload: licenseStatus,
  };
};

export const verifyLicenseFailure = (error) => {
  return {
    type: VERIFY_LICENSE_ERROR,
    payload: error,
  };
};

export const verifyLicense = (license_key) => {

    const payload = {
        license_key:license_key
    }
    const headers = {
        'Content-Type': 'application/json',
        };
  return async (dispatch) => {
    dispatch(verifyLicenseRequest());
    try {
        const response = await api.post("user/license_key/verify", payload, {
            headers: headers,
          });
      const verifyLicenseData = response.data;
      //console.log("verifyLicenseData", verifyLicenseData)
      dispatch(verifyLicenseSuccess(verifyLicenseData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(verifyLicenseFailure(errorMsg));
    }
  };
};
